import { useCallback, useRef } from "react";
import { getProvider } from "@/containers/swapToken/utils";
import { CACHE_TTL } from "@/utils/constant";

interface CachedGasPrice {
  price: number;
  timestamp: number;
}

let gasPriceCache: CachedGasPrice | null = null;

export default function useGetGasPrice() {
  const cacheRef = useRef<CachedGasPrice | null>(null);

  const getGasPrice = useCallback(async () => {
    const now = Date.now();

    // Return cached price if still valid
    if (cacheRef.current && now - cacheRef.current.timestamp < CACHE_TTL) {
      return cacheRef.current.price;
    }

    try {
      const provider = getProvider();
      if (!provider) return 0;

      const feeData = await provider.getFeeData();
      const price = feeData?.gasPrice ? feeData.gasPrice.toNumber() / 10 ** 9 : 0;

      // Update cache
      cacheRef.current = { price, timestamp: now };
      return price;
    } catch (error) {
      console.error("Error fetching gas price:", error);
      // Return last cached price if available, otherwise 0
      return cacheRef.current?.price ?? 0;
    }
  }, []);

  return getGasPrice;
}
